import { Link } from 'react-router-dom';
import React from 'react';
import { useGlobalLocale } from '@gov-nx/core/service';
import { Icon } from '../Icon';

export interface LogoProps {
	href?: string;
	ariaLabel?: string;
}

export const Logo = ({ href = '/', ariaLabel }: LogoProps) => {
	const { t } = useGlobalLocale();
	return (
		<Link
			to={href}
			aria-label={ariaLabel ? ariaLabel : t('odkaz.zpet-na-hp')}
			className="flex shrink-0 w-[130px]">
			<Icon
				name="logo"
				type="colored"
				className="h-[2.5rem] dark:hidden!"
			/>
			<Icon
				name="logo-white"
				type="colored"
				className="h-[2.5rem] hidden! dark:block!"
			/>
		</Link>
	);
};
